import Needs from "@/views/needs/Needs.vue";

export default [
    {
        path: '/needs',
        component: Needs,
        meta: {
            access: ['admin'],
        }
    },
]
